import { createFileRoute, redirect } from "@tanstack/react-router";
import { CargarCFDIPage } from "@/features/cargar-cfdi/components/CargarCFDIPage";
import { pasoActivo, urlPorPaso } from "@/components/solicitudes/stepper/state-mapping";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/cargar-cfdi")({
  beforeLoad: async (ctx) => {
    await requerirEdicionDeSolicitud(ctx);
    const { context: { queryClient }, params: { id } } = ctx;
    const sol = await queryClient.ensureQueryData(solicitudQueryOptions(id));
    if (sol.subtipo === "CONTRAPAGO") {
      const paso = pasoActivo(sol.estado, sol.tipo, sol.subtipo, sol.esperaCfdiConciliadoAt);
      const destino = paso === "terminal-positivo" ? `/solicitudes/${id}` : (urlPorPaso(paso, id, false, true) ?? `/solicitudes/${id}`);
      throw redirect({ to: destino as never });
    }
  },
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: CargarCFDIPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
